// Types
const action_header = "reportmanagement/";
export default {
  GET_EXPORT_DETAILS: action_header + "GET_EXPORT_DETAILS",
  GET_EXPORT_DETAILS_SUCCESS: action_header + "GET_EXPORT_DETAILS_SUCCESS",
  GET_EXPORT_DETAILS_FAILED: action_header + "GET_EXPORT_DETAILS_FAILED",

};
